import forEach from 'lodash/forEach';

import { caseLogicMsg } from '../validationMessages';

function validateCustomMenuNodes(caseConf, nodeInfo) {
  const errors = [];

  // Actions
  nodeInfo.actionNodes.forEach(node => {
    const { action } = node.data;
    if (!action || action.type !== 'CUSTOM_MENU') {
      return;
    }
    if (!action.parentId) {
      errors.push(
        caseLogicMsg('Must select parent button', node.id, { errorId: 'customMenuParent' })
      );
      return;
    }
    const customMenu = (caseConf.customMenus || []).find(
      menu => menu.category === action.id
    );
    const parentMenu = customMenu.items.find(menu => menu.id === action.parentId);
    if (!parentMenu) {
      errors.push(
        caseLogicMsg('Button not found', node.id, { errorId: 'customMenuParent' })
      );
    } else {
      if (action.childId && !parentMenu.children.find(menu => menu.id === action.childId)) {
        errors.push(
          caseLogicMsg('Button not found', node.id, { errorId: 'customMenuChild' })
        );
      }
    }
  });

  // Checks
  nodeInfo.checkNodes.forEach(node => {
    forEach(node.data, (check, checkKey) => {
      if (check.type !== 'CUSTOM_MENU') {
        return;
      }
      if (!check.parentId) {
        errors.push(
          caseLogicMsg('Must select parent button', node.id, { checkKey, errorId: 'customMenuParent' })
        );
        return;
      }
      const customMenu = (caseConf.customMenus || []).find(
        menu => menu.category === check.id
      );
      const parentMenu = customMenu.items.find(menu => menu.id === check.parentId);
      if (!parentMenu) {
        errors.push(
          caseLogicMsg('Button not found', node.id, { checkKey, errorId: 'customMenuParent' })
        );
      } else {
        if (check.childId && !parentMenu.children.find(menu => menu.id === check.childId)) {
          errors.push(
            caseLogicMsg('Button not found', node.id, { checkKey, errorId: 'customMenuChild' })
          );
        }
      }
    });
  });

  // Effects
  nodeInfo.effectNodes.forEach(node => {
    const { effect } = node.data;
    if (!effect || effect.type !== 'CUSTOM_MENU') {
      return;
    }
    if (!effect.parentId) {
      errors.push(
        caseLogicMsg('Must select parent button', node.id, { errorId: 'customMenuParent' })
      );
      return;
    }
    const customMenu = (caseConf.customMenus || []).find(
      menu => menu.category === effect.id
    );
    const parentMenu = customMenu.items.find(menu => menu.id === effect.parentId);
    if (!parentMenu) {
      errors.push(
        caseLogicMsg('Button not found', node.id, { errorId: 'customMenuParent' })
      );
    } else {
      if (effect.childId && !parentMenu.children.find(menu => menu.id === effect.childId)) {
        errors.push(
          caseLogicMsg('Button not found', node.id, { errorId: 'customMenuChild' })
        );
      }
    }

  });

  return {
    errors,
    warnings: [],
  };
}
export default validateCustomMenuNodes;